import { CallRow } from '@/services/call-log-service/call-log-service.types';
import { StatusBadgeVariant } from './status-badge.types';

/**
 * Handed off means a human took the call: an Agent step, or an end_reason naming someone
 * else. `agent` alone misses a department redirect. 'Caller in queue' is excluded, the
 * resident hung up waiting so no clerk received it.
 */
const HANDOFF_END_REASONS = ['Agent', 'Specific Individual'];

export const isHandedOff = (call: Pick<CallRow, 'agent' | 'end_reason'>): boolean =>
  call.agent || (call.end_reason !== null && HANDOFF_END_REASONS.includes(call.end_reason));

/**
 * Handoff outranks resolution, because a handed-off call is also a closed one. `visit` is
 * never returned: nothing we serialize can derive it. `live` is claimed explicitly rather
 * than taken as a fallthrough, so a status outside the two we know does not read as a call
 * still in progress.
 */
export const deriveStatusVariant = (
  call: Pick<CallRow, 'agent' | 'status' | 'end_reason'>
): Exclude<StatusBadgeVariant, 'visit'> => {
  if (isHandedOff(call)) return 'hand';
  if (call.status === 'live') return 'live';
  return 'ok';
};
